<div class="content-inner loading" *ngIf="loading"></div>

<ng-template [ngIf]="!loading">      
    <div class="content-inner">
        <div class="workflow-section-heading">Room Activity Categories</div>

        <section [formGroup]="currentBlockForm" class="form-body" >
            <div *ngFor="let roomType of shiftRecord.costCenter.ancillaryConfiguration.roomTypes">
                {{ roomType.name }}
                <div *ngFor="let room of roomType.rooms" class="room">
                    <label>{{ room.name }}</label>
                    <select name="acuityCategory" formControlName="room{{room.id}}">
                        <option value=""> </option>
                        <option value="vacant">No Occupancy</option>
                        <option *ngFor="let acuityCategory of acuityCategories"
                            [value]="acuityCategory.id">
                            {{ acuityCategory.name }}                        
                        </option>
                    </select>
                </div>
            </div>
        </section>

        <!-- Staffing -->
        <section [formGroup]="staffForm" class="staff-form">
            <div class="workflow-section-heading">Enter Staffing Levels</div>
            <div class="loading" *ngIf="loadingRecommendations"></div>
            <ng-container *ngIf="jobTitlesWithVariance.length > 0">
              <div class="warning notification" *ngFor="let varianceWarning of getVarianceWarnings()">
                <span class="icon-notification"></span> {{ varianceWarning }}
              </div>
            </ng-container>
            <div class="warning notification" *ngIf="hasRatioBasedRecommendation">{{ ratioStaffTarget }} Staff Recommended Based on Staff:Patient Ratios for: {{ ratioStaffLabels }}</div>
            <section *ngIf="shiftRecord.costCenter?.variableJobTitles?.length > 0" class="workflow-input-group">
                <div class="workflow-section-subheading">Variable Staff</div>
                <div class="workflow-input-labels">
                    <span>Target</span>
                    <span>Actual</span>
                </div>
                <div class="workflow-input" *ngFor="let varStaff of shiftRecord.costCenter.variableJobTitles">
                    <input type="text" disabled [attr.aria-label]="'Target ' + varStaff.abbreviation" [value]="getRecommendedStaffText(varStaff.id)">
                    <input type="number" min="0" [attr.aria-label]="'Actual ' + varStaff.abbreviation" [formControlName]="getStaffControlName(varStaff.id)">
                    <span class="display-label">{{ varStaff.abbreviation }}</span>
                    <div *ngIf="controlValueOutOfRange(varStaff.id)" class="validation-message warning">
                        Value must be between {{minValue}} and {{maxValue | number}}.
                    </div>
                </div>
            </section>

            <section *ngIf="shiftRecord.costCenter?.fixedJobTitles?.length > 0" class="workflow-input-group">
                <a class="workflow-section-link" (click)="toggleFixedStaff()">Fixed Staff</a>  
                &nbsp;
                <button class="compact" (click)="toggleFixedJobEditing(true)"><span class="icon-pencil"></span> Edit</button>
                <ng-template [ngIf]="showFixedStaff">  
                    <div class="workflow-input-labels">
                        <span>Target</span>
                        <span>Actual</span>
                    </div>
                    <div class="workflow-input" *ngFor="let fixed of shiftRecord.costCenter.fixedJobTitles">
                        <input type="text" disabled [attr.aria-label]="'Target ' + fixed.abbreviation" [value]="getRecommendedStaffText(fixed.id)">
                        <input type="number" min="0" [attr.aria-label]="'Actual ' + fixed.abbreviation" [formControlName]="getStaffControlName(fixed.id)">
                        <span class="display-label">{{ fixed.abbreviation }}</span>
                        <div *ngIf="controlValueOutOfRange(fixed.id)" class="validation-message warning">
                            Value must be between {{minValue}} and {{maxValue | number}}.
                        </div>
                    </div>
                </ng-template>
            </section>
        </section>
        </div>
</ng-template>
